import React from 'react'
import { Grid } from '@mui/material'
import { AutocompleteProducto } from '../../comp/AutocompleteProducto'
import { InputEntero } from '../../comp/Input'
import { InputFecha } from '../../comp/InputFecha'
import { InputSelect } from '../../comp/InputSelect'
import { FiltroEstadoActivo } from '../../comp/FiltroEstadoActivo'
import { ModalDetail } from '../../comp/ModalDetail'
import { ModalSearch } from '../../comp/ModalSearch'
import { Traduccion } from '../../comp/Traduccion'
import { EstadoFormulario } from '../../utils/Constantes'
import { agregarLote, editarLote } from '../../services/servProductos'
import { Acciones } from '../../utils/Acciones'
import { Messages } from '../../comp/Messages2'

export const Filtros = ({ filtros, isOpen, onSubmit }) => {

    const [form, setForm] = React.useState(filtros)
    const handleFormChange = (val, field) => setForm({...form, [field]: val})
    const handleSubmit = (res) => onSubmit(res, {...form})
    const opcionesVencimiento = () => {
        let aux = [
            {label: Traduccion('TXT_PROXIMO_A_VENCER'), value: 2},
            {label: Traduccion('TXT_VENCIDO'), value: 3},
        ]
        aux.sort((e1, e2) => e1.label.localeCompare(e2.label))
        aux.unshift({label: Traduccion('TXT_SELECCION_TODOS'), value: 1})
        return aux
    }

    React.useEffect(() => { if (isOpen) setForm(filtros) }, [filtros, isOpen])

    return <ModalSearch isOpen={isOpen} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <InputEntero id='numero'
                    label={Traduccion('TXT_NUMERO')}
                    value={form.numero}
                    onChange={handleFormChange}
                    autoFocus />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteProducto id='producto' 
                    seleccion={form.producto}
                    onSelect={handleFormChange}
                    clearOnSelect />
            </Grid>
            <Grid item xs={12}>
                <InputSelect id='estadoVencimiento'
                    label={Traduccion('TXT_VENCIMIENTO')}
                    value={form.estadoVencimiento}
                    onChange={handleFormChange}
                    options={opcionesVencimiento()}/>
            </Grid>
            <Grid item xs={12}>
                <FiltroEstadoActivo id='activo'
                    value={form.activo}
                    onChange={handleFormChange} />
            </Grid>
        </Grid>
    </ModalSearch>
}

export const Detalle = ({ accion, isOpen, onSubmit, seleccion}) => {

    const [form, setForm] = React.useState({})
    const [formStatus, setFormStatus] = React.useState(EstadoFormulario.PREPARADO)
    const [resServicio, setResServicio] = React.useState()
    
    const handleFormChange = (val, field) => setForm({...form, [field]: val})
    const obligatoriosConValor = () => form.producto && form.numero

    const handleSubmit = async (res) => {
        let datosFormulario = {
            ...form,
            recepcion: form.recepcion ?? new Date(),
            activo: form.activo ?? true
        }
        if (!res) return onSubmit()
        if (res && !obligatoriosConValor()) return setFormStatus(EstadoFormulario.CON_ERRORES)
        let resServ = (accion === Acciones().ADD)
            ? await agregarLote(datosFormulario)
            : await editarLote(datosFormulario)
        if (resServ.errores) return setResServicio(resServ)
        datosFormulario.id = datosFormulario.id ?? resServ.data.id
        onSubmit(datosFormulario)
    }

    React.useEffect(() => {
        if (isOpen) {
            setForm(seleccion)
            setFormStatus(EstadoFormulario.PREPARADO)
            setResServicio()
        }
    }, [seleccion, isOpen])

    return <>
        <ModalDetail accion={accion} isOpen={isOpen} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <AutocompleteProducto id='producto' 
                        seleccion={form.producto}
                        onSelect={handleFormChange}
                        clearOnSelect requerido autoFocus
                        validarSubmit={formStatus === EstadoFormulario.CON_ERRORES} />
                </Grid>
                <Grid item xs={12}>
                    <InputEntero id='numero'
                        label={Traduccion('TXT_NUMERO')}
                        value={form.numero}
                        onChange={handleFormChange}
                        requerido
                        validarSubmit={formStatus === EstadoFormulario.CON_ERRORES} />
                </Grid>
                <Grid item xs={12}>
                    <InputFecha id='vencimiento'
                        label={Traduccion('TXT_VENCIMIENTO')} 
                        value={form.vencimiento}
                        onChange={handleFormChange} />
                </Grid>
            </Grid>
        </ModalDetail>
        <Messages resServicio={resServicio} accion={accion} />
    </>
}